import type { IconName } from "@salestrak/ui";
import { ENTITY_KIND_ICON } from "#app/lib/entity-visuals";
import type { SearchKind } from "#app/lib/hooks/use-global-search";

// One record per result kind: the chip's label and category glyph, the noun
// the per-kind "Load more" row names (the chip label is not reliably plural:
// "Address" would read "Load more address"), and the singular footer label.
// Chip icons are the chips' own vocabulary, not ENTITY_KIND_ICON: the filter
// row reads as categories (a box of projects, a circled member), not as
// entity glyphs. Record order is chip order and result order.
export const SEARCH_KIND_META: Record<
  SearchKind,
  { label: string; plural: string; singular: string; icon: IconName }
> = {
  issue: { label: "Projects", plural: "projects", singular: "Project", icon: "box" },
  address: { label: "Address", plural: "addresses", singular: "Address", icon: "map-pin" },
  user: { label: "Members", plural: "members", singular: "Member", icon: "circle-user" },
  team: { label: "Teams", plural: "teams", singular: "Team", icon: ENTITY_KIND_ICON.team },
};

// Scoped-search filter chips (multi-select, none selected by default). No
// selection = every kind shows; selecting chips narrows the list client-side.
// With an EMPTY query, selected chips enter browse mode: the launcher swaps
// to a Results list of that kind from data already on the client (members,
// teams, recent projects) — so a chip press always visibly does something.
export const SEARCH_FILTERS = (Object.keys(SEARCH_KIND_META) as SearchKind[]).map((value) => ({
  value,
  ...SEARCH_KIND_META[value],
}));

// What ↵ does on an address row, by the viewer's case: a desktop viewer who
// can create projects gets a draft at the address; anyone else lands on the
// map there. Read by the footer context and the ↵ tooltip alike.
export const ADDRESS_ACTION_LABEL = {
  create: "Create Project",
  open: "Open on map",
} as const;

// Rows the launcher's "Results" recents section shows (of the store's 20).
export const RESULTS_COUNT = 5;

// Rows per kind in chip browse mode (empty query + selected chips). Capped —
// the list isn't virtualized, and typing narrows past it anyway.
export const BROWSE_COUNT = 20;
